<template>
  <div class="player-box">
    <div>
      <div :id="containerId" :style="{ height: height || '400px' }"></div>
    </div>
  </div>
</template>

<script>
import { EZUIKitPlayer } from 'ezuikit-js'

export default {
  name: 'Player',
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    videoUrl: {
      type: String,
      default: ''
    },
    template: {
      type: String,
      default: 'pcLive'
    }
  },
  data() {
    return {
      player: null,
      containerId: `video-container-${this._uid}`,
      accessToken: ''
    }
  },
  created() {
    this.accessToken = localStorage.getItem('hsAccessToken') || ''
  },
  beforeDestroy() {
    this.destroy()
  },
  watch: {
    videoUrl: {
      handler() {
        this.init()
      },
      immediate: true
    },
    template() {
      if (this.videoUrl) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      if (!this.videoUrl) return
      this.$nextTick(() => {
        const el = document.getElementById(this.containerId)
        if (!el) return
        if (this.player) {
          this.destroy()
        }
        this.player = new EZUIKitPlayer({
          id: this.containerId,
          accessToken: this.accessToken,
          url: this.videoUrl,
          template: this.template,
          width: this.width,
          height: this.height,
          autoPlay: true,
          audio: true,
          download: true,
          downloadRecord: true,
          handleError: (error) => {
            console.error('handleError', error)
          },
          scaleMode: 1,
          env: {
            domain: 'https://open.ys7.com'
          },
          loggerOptions: {
            level: 'INFO',
            name: 'ezuikit',
            showTime: true
          },
          streamInfoCBType: 1
        })

        // this.player.on(EZUIKitPlayer.EVENTS.videoInfo, (info) => {
        //   console.warn('videoInfo', info)
        // })
        // this.player.on(EZUIKitPlayer.EVENTS.audioInfo, (info) => {
        //   console.warn('audioInfo', info)
        // })
        // this.player.on(EZUIKitPlayer.EVENTS.firstFrameDisplay, () => {
        //   console.warn('firstFrameDisplay ')
        // })
        // this.player.on(EZUIKitPlayer.EVENTS.streamInfoCB, (info) => {
        //   console.warn('streamInfoCB ', info)
        // })
      })
    },

    destroy() {
      if (this.player) {
        this.player.destroy().then((data) => {
          console.log('promise 获取 数据', data)
        })
        this.player = null
      }
    }
  }
}
</script>
<style lang="less" scoped>
.player-box {
  width: 100%;
  height: 100%;
  div {
    width: 100%;
    height: 100%;
  }
}
</style>
